export default "__VITE_ASSET__C2o$DjMf__"